import React from 'react';

export default function MiniGolf() {
	// 12
	let style = {
		st24: {
			fill:"#FC5959"
		},
		st19: {
			fill:"#75C69F"
		},
		st3: {
			fill:"#66AA88"
		},
		st92: {
			fill:"#4D4D4D"
		},
		st0: {
			fill:"#FFFFFF"
		},
		st16: {
			fill:"#E6E6E6"
		}
	};
	return (
		<g>
			<polygon style={style.st24} points="76.9270248,310.4536133 24.18787,285.7267151 76.8113022,261.3862 	"/>
			<path style={style.st19} d="M27.2711525,406.002594c0,0,0.4094181-8.2949829,1.755415-9.1663513
				c1.0367985-0.6711731,3.3351002,0.6379089,4.6362514,0.0041809c1.1029434-0.5372009,1.4021645-4.7505798,2.6834297-5.2579041
				c1.1385155-0.4508057,3.0941658,2.8613281,4.3655243,2.4361572c1.160656-0.3881226,1.7321739-4.5519714,2.9975777-4.9172363
				c1.1757431-0.3393555,2.9561462,3.1423645,4.2175789,2.8239746c1.1866951-0.29953,1.9167557-4.4176025,3.1753654-4.6975708
				c1.1923485-0.2652283,2.8529243,3.3193665,4.1064911,3.0725403c1.1993065-0.236145,2.0383759-4.3142395,3.2908211-4.5327759
				c1.2050438-0.2102966,2.7777176,3.4460449,4.029377,3.2527161c1.2098923-0.1868896,2.1369247-4.2301636,3.3880539-4.4006042
				c1.2140656-0.1654053,2.7146759,3.5464783,3.9654617,3.3970947c1.2177124-0.1454773,2.2184982-4.1567078,3.4690628-4.2864685
				c1.2197342-0.1265869,2.656723,3.6311951,3.9059067,3.519989c1.2212448-0.1087341,2.284111-4.0895081,3.5318298-4.183136
				c1.2232361-0.0917664,2.6021347,3.7054749,3.8492203,3.6286316c1.2242126-0.0754395,2.3437958-4.0269165,3.5894928-4.0875854
				c1.2281494-0.0597839,2.5553894,3.7723389,3.8029861,3.7272644c1.2285309-0.0443726,2.4031525-3.9671326,3.6491776-3.9968872
				c1.2310333-0.0293884,2.507782,3.8346558,3.7545776,3.8198853c1.2320099-0.0146179,2.4589539-3.9085083,3.7050781-3.9085083
				c1.243187,0,2.4672546,3.8938599,3.6963959,3.9083862c1.2436218,0.0147095,2.5171585-3.8494568,3.7451172-3.8201904
				c1.2440109,0.0296326,2.4168015,3.95224,3.6433868,3.99646c1.2450638,0.0448608,2.5696259-3.7874756,3.7953339-3.7279358
				c1.2462616,0.0605469,2.3666229,4.0119629,3.5914001,4.0872803c1.2474289,0.0767212,2.6264572-3.7206116,3.8500443-3.6289368
				c1.2485886,0.0935364,2.3125305,4.0742493,3.5346298,4.1829529c1.2496948,0.1111145,2.6869812-3.646759,3.9072266-3.5202332
				c1.2507477,0.1296692,2.2519226,4.1408081,3.4698181,4.2861633c1.251709,0.1493835,2.7530212-3.562561,3.9679871-3.3971558
				c1.2525635,0.1705322,2.1812134,4.2138977,3.3924866,4.4009094c1.2532959,0.1934509,2.8274078-3.462738,4.0339966-3.2522583
				c1.2538757,0.218689,2.0944519,4.2969971,3.2950897,4.5333557c1.2561646,0.2472534,2.9191742-3.336853,4.1138916-3.071106
				c1.2592926,0.2801208,1.9899902,4.3983459,3.1772919,4.6980286c1.2617798,0.318512,3.0425415-3.1631165,4.2185822-2.8236389
				c1.2661591,0.3654785,1.8382874,4.5295715,2.9995575,4.9179993c1.2714691,0.4252625,3.227356-2.8866882,4.365921-2.4357605
				c1.2853241,0.5090332,1.5874786,4.723999,2.6932526,5.2631226c1.3022156,0.6348572,3.6025085-0.6836243,4.6394653-0.0112
				c1.3427734,0.8707581,1.7380829,7.5657043,1.7380829,9.1663513"/>
			<ellipse style={style.st19} cx="103.1399689" cy="406.002594" rx="75.8688126" ry="19.6074219"/>
			<path style={style.st3} d="M175.8318634,408.002594c-0.9623108,0.8867188-1.0114899,4.5030823-2.4411926,5.3554382
				c-1.1113129,0.6625366-3.331131-2.3276062-4.7079773-1.7053833c-1.1736603,0.530365-1.6669769,4.7740479-3.0211029,5.2718811
				c-1.2071533,0.4438171-3.1284485-2.903595-4.4703674-2.4878845c-1.2282867,0.3805237-1.9601593,4.5561523-3.2948303,4.9114075
				c-1.2428284,0.3308411-3.0080719-3.1768494-4.3379364-2.8692322c-1.2499542,0.289093-2.1199341,4.4089966-3.4424591,4.6764832
				c-1.2587585,0.2545776-2.9152985-3.3527222-4.2360992-3.1187134c-1.2658539,0.2242737-2.2386017,4.2987976-3.5581818,4.5033264
				c-1.2717285,0.1971436-2.8480225-3.4812622-4.166748-3.3032227c-1.2766724,0.1723938-2.3311615,4.2068481-3.6492615,4.3606873
				c-1.2792511,0.149292-2.7868958-3.5855103-4.1027679-3.4543457c-1.2814484,0.1277771-2.4020233,4.1251831-3.716011,4.2352295
				c-1.284111,0.1075134-2.7308426-3.6744995-4.0439682-3.5844421c-1.2870865,0.0882874-2.4687347,4.0509338-3.7817688,4.1219177
				c-1.2898483,0.0697021-2.6829987-3.753418-3.996048-3.7008362c-1.290451,0.0516663-2.5272064,3.9804382-3.8383255,4.0150757
				c-1.2934952,0.0341797-2.6349716-3.8261719-3.9469147-3.8089905c-1.2947311,0.0169678-2.5853271,3.9120483-3.8964157,3.9120483
				c-1.3081207,0-2.5958023-3.89505-3.8876266-3.9119263c-1.3094788-0.0171204-2.6484375,3.8433533-3.939537,3.8092957
				c-1.3108139-0.0345764-2.5473862-3.9632263-3.8375473-4.014801c-1.3121414-0.0524597-2.7042847,3.7707825-3.9932709,3.7012024
				c-1.3134537-0.0709229-2.4956741-4.0335083-3.7831879-4.1217041c-1.314743-0.0900879-2.7629395,3.6918945-4.0486069,3.5843201
				c-1.315979-0.1101379-2.4385986-4.107666-3.7219543-4.2355957c-1.3171539-0.1312561-2.826004,3.6034546-4.1064606,3.4540405
				c-1.3182526-0.1538086-2.3729324-4.1882935-3.6497498-4.3606567c-1.3192368-0.1781006-2.8959961,3.5002747-4.1681976,3.3031006
				c-1.3200989-0.2046204-2.2933617-4.2792053-3.5596886-4.5035706c-1.3230782-0.2344055-2.9818306,3.372467-4.2426643,3.1174316
				c-1.3265572-0.2683411-2.2001991-4.3891602-3.4537315-4.6792603c-1.329525-0.3077087-3.0947304,3.1997986-4.3372078,2.868866
				c-1.3348808-0.3555603-2.0666237-4.5313721-3.2949944-4.9121399c-1.3413582-0.4158325-3.2625847,2.9313354-4.4691391,2.4874268
				c-1.3568535-0.4992065-1.8518753-4.743988-3.027317-5.2758789c-1.3769569-0.6230774-3.5983963,2.3653564-4.7091599,1.7018738
				c-1.4249859-0.8511353-1.2632065-5.0989075-2.2151222-6.0075073c-1.5787907-1.5069275-2.8999119,3.1349487-3.4671707-1.3349609
				l-0.008007,9.0110168c0,5.4053345,12.2572899,10.5926819,21.1973572,12.9016724
				c14.6661034,3.7880859,34.0673447,5.9004211,54.6754608,5.9004211s40.0093613-2.1123352,54.6754684-5.9004211
				c8.9400635-2.3089905,21.1973572-6.3394775,21.1973572-14.9241028l-0.0080109-6.8427124
				C178.6024628,409.1848145,177.5551758,406.4147034,175.8318634,408.002594z"/>
			<ellipse style={style.st92} cx="79.0696793" cy="404.2949219" rx="17.9303246" ry="4.371747"/>
			<circle style={style.st0} cx="134.2957306" cy="399.4878235" r="10.222209"/>
			<circle style={style.st16} cx="127.6634598" cy="398.818512" r="1.2777761"/>
			<circle style={style.st16} cx="133.565567" cy="406.3026428" r="1.2777761"/>
			<circle style={style.st16} cx="133.2004852" cy="400.6439209" r="1.2777761"/>
			<circle style={style.st16} cx="128.9412384" cy="403.7470703" r="1.2777761"/>
			<circle style={style.st16} cx="138.5" cy="404" r="1.2777761"/>
			<circle style={style.st16} cx="130.644928" cy="394.4578552" r="1.2777761"/>
			<path style={style.st3} d="M61.1394043,404.2949219c0.0002441,0.8098145,0.9191895,1.5656738,2.4931641,2.2158203
				c3.1213379-1.2856445,8.8586426-2.1491699,15.4309082-2.1491699c6.5766602,0,12.3171387,0.8647461,15.4370117,2.1518555
				C96.078125,405.8625488,96.9997559,405.105957,97,404.2949219c-0.0002441-0.7543945-0.7841797-1.4643555-2.1640625-2.0837402
				c-0.276123-0.1240234-0.5759277-0.2443848-0.8981934-0.3605957c-1.9963379-0.720459-4.8566895-1.2851562-8.2114258-1.612793
				c-2.0598145-0.2009277-4.302002-0.3144531-6.65625-0.3144531c-4.9516602,0-9.4343262,0.4892578-12.6789551,1.2802734
				c-0.4057617,0.098877-0.7919922,0.2026367-1.1572266,0.3105469c-0.8537598,0.2521973-1.5771484,0.5302734-2.184082,0.8254395
				C61.8378906,402.9284668,61.1396484,403.5913086,61.1394043,404.2949219z"/>
			<path style={style.st0} d="M81.6666641,408.6211548c0,0-1.0934067,0.0455017-2.465332,0.0455017
				c-1.3719177,0-2.465332-0.0366821-2.465332-0.0366821V261.2319336h4.9306641V408.6211548z"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/MiniGolf.js